import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import SourceList from './source_list';

class SourceSetting extends Component {
    render() {
        return (
            <Switch>
                <Route path="/settings/sources" component={SourceList} />
                <Redirect from="*" to="/settings/sources"/>
            </Switch>
        )
    }
}

export default SourceSetting;
